// extracted by mini-css-extract-plugin
module.exports = {"root":"AppStarRating_root__wqGC2","ratingLabel":"AppStarRating_ratingLabel____Hhe"};